import { gql } from "~/__generated__"

export const AGENCY_PUBLIC_MEDIA_KIT_UPDATE_MUTATION = gql(`
  mutation AgencyPublicMediaKitUpdate(
    $input: AgencyPublicMediaKitUpdateInput!
  ) {
    agencyPublicMediaKitUpdate(input: $input) {
      agency {
        id
        publicMediaKitEnabled
        publiclyViewable
      }
    }
  }
`)
